export function transformBackstreet(response) {
  if(response.config.url.indexOf('backstreet') > -1) {
    response.data = response.data.body;
  }
  return response;
}

export function expandData(response) {
  if(response.data) {
    return response.data;
  }
  return response;
}


export const httpLog = (logger = console) => (response) => {
  if(process.env.production != 'production') {
    logger.debug('\r\n\r\n\r\n',response.config.url);
    logger.debug(response.data);
  }
  return response
}

export function successErrorMsg(response) {
  if((response.data.errorMsg && response.data.success === false) || (response.data.result&&!response.data.result.success === false)){
    throw response.data;
  }
  return response;
}



// WEBPACK FOOTER //
// ./utils/httpTransform.js